import $ from 'jquery';
import React from 'react';
import OptionPopupView from "views/common/OptionPopupView";
import { createRoot } from "react-dom/client";
import { WorkspaceBillingContent } from '../../components/workspace/WorkspaceBillingContent';

const WorkspaceBillingPopupView = OptionPopupView.extend({

    "pageName": "Workspace Billing Popup",

    initialize: function(options) {
        this._workspace = options.workspace;
        this._onManageBilling = options.onManageBilling;
        this._onUpdateSeats = options.onUpdateSeats;
        this._onCancel = options.onCancel;
        this._i18nModule = options.i18nModule;
        this._reactRoot = null;

        // Create content container for React component
        this.contentContainer$el = $('<div class="workspace-billing-popup-content"></div>');
        this.contentContainer$el.css("width", "calc(100% - 40px)");
        this.contentContainer$el.css("max-width", "500px");

        // Configure OptionPopupView
        const contentView = {};
        contentView.$el = this.contentContainer$el;

        const viewOptions = {
            contentView: contentView,
            contentPosition: "text-not-white",
            addContentAfterEnhancement: true,
            displayTitle: false,
            id: "WorkspaceBillingPopup"
        };

        OptionPopupView.prototype.initialize.call(this, viewOptions);
    },

    onPopupClosed: function() {
        if (this._reactRoot) {
            this._reactRoot.unmount();
            this._reactRoot = null;
        }
    },

    onCloseTriggered: function() {
        this.close();
    },

    addReactWidget: function() {
        if (this._reactRoot) {
            this._reactRoot.unmount();
        }

        const root = createRoot(this.contentContainer$el.get(0));

        root.render(
            React.createElement(WorkspaceBillingContent, {
                workspace: this._workspace,
                onManageBilling: this._onManageBilling,
                onUpdateSeats: this._onUpdateSeats,
                onCancel: this._onCancel,
                onClose: this.onCloseTriggered.bind(this),
                i18nModule: this._i18nModule
            })
        );

        this._reactRoot = root;
    },

    updateWorkspace: function(workspace) {
        this._workspace = workspace;
        this.addReactWidget();
    },

    onAfterPageShow: function() {
        this.addReactWidget();
    },

    afterRender: function() {
        OptionPopupView.prototype.afterRender.call(this);
    }
});

export default WorkspaceBillingPopupView;
